const PY = {
  countryConfig: {
    IBAN: {
      visible: false,
    },
    accountHolderDocNumber: {
      label: "bankDetails.CUIT",
      required: true,
    },
    bankName: {
      label: "bankDetails.bankName",
      visible: true,
      required: true,
    },
    accountNumber: {
      visible: true,
      required: true,
      label: "bankDetails.accountNumber",
    },
    swift: {
      visible: true,
      required: true,
      label: "bankDetails.swift",
    },
    bankAddress: {
      visible: false,
      required: false,
    },
  },
};
export { PY };
